var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"title"},[_vm._v(" Bitte wählen Sie einen Termin aus. ")]),_c('WeeklyCalendar',{on:{"notify":this.notify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }